import { InteractiveMaterialResponseDto } from "@packages/api/madlenAPI.schemas";
import { useEffect, useState } from "react";
import RichHTMLTextEditor from "../tool_components/RichHTMLTextEditor";

interface SummaryTabProps {
  material: InteractiveMaterialResponseDto;
  onSummaryChange?: (summary: string) => void;
}

const SummaryTab = ({ material, onSummaryChange }: SummaryTabProps) => {
  const [summary, setSummary] = useState<string>(material.summary || "");

  useEffect(() => {
    setSummary(material.summary || "");
  }, [material.summary]);

  const handleSummaryChange = (value: string) => {
    setSummary(value);
    onSummaryChange?.(value);
  };

  return (
    <div className="h-[calc(100vh-7rem)] max-h-[900px] min-h-[600px] flex flex-col items-center justify-center overflow-scroll">
      <div className="w-full h-full">
        <RichHTMLTextEditor value={summary} onChange={handleSummaryChange} />
      </div>
    </div>
  );
};

export default SummaryTab;
